import React from 'react';

import Text from '../text/text';
import './player-card-footer.scss';
import { makeClassNames } from '../../../utils/styles';
import { sportsDetailCardtypes } from '../../../typings/sports-detail';
import IconChevronRight from '../icons/icon-chevron-right';

const classNames = (params: { type: sportsDetailCardtypes | string; bgColor: string }) => {
  const { type = '', bgColor } = params;

  return makeClassNames({
    infoWrapper: [
      'player-card-footer__info-wrapper',
      `player-card-footer__info-wrapper--${type}`,
      `player-card-footer__info-wrapper--${bgColor}`,
    ],
    info: 'player-card-footer__info',
    arrow: 'player-card-footer__arrow',
    name: 'player-card-footer__name',
    score: 'player-card-footer__score',
    uppercase: 'player-card-footer__text--uppercase',
    underlined: 'player-card__text--underlined',
    spaced: 'player-card-footer__text--spaced',
    points: 'player-card-footer__points',
    role: 'player-card-footer__role',
  });
};

export interface IPlayerCardFooter {
  type: sportsDetailCardtypes;
  firstName?: string;
  lastName: string;
  url?: string;
  label: string;
  points?: number;
  showPoints: boolean;
  role?: string;
  teamName?: string;
  bgColor: 'blue' | 'light';
}

const PlayerCardFooter = (props: IPlayerCardFooter) => {
  const { type, firstName, lastName, url, label, points, showPoints, role, teamName, bgColor } = props;

  const cn = classNames({ type, bgColor });

  const color = bgColor === 'blue' ? 'light' : 'blue';

  return (
    <div className={cn.infoWrapper}>
      <div className={cn.info}>
        {showPoints ? (
          <div className={cn.score}>
            <Text className={cn.uppercase} tag="span" fontSize="14" fontWeight="500" color={color}>
              {label}
            </Text>
            <Text className={cn.points} tag="span" fontSize="32--34" fontWeight="500" color={color}>
              {type === sportsDetailCardtypes.MARCATORI ? points : points?.toLocaleString('it-IT') || 'S.V.'}
            </Text>
          </div>
        ) : null}
        <div className={cn.name}>
          {firstName &&
          type !== sportsDetailCardtypes.MARCATORI &&
          type !== sportsDetailCardtypes.DRIVERS &&
          type !== sportsDetailCardtypes.TEAMS ? (
            <Text tag="span" fontSize="16" color={color}>
              {firstName}
            </Text>
          ) : null}

          {firstName && type === sportsDetailCardtypes.DRIVERS ? (
            <Text tag="span" fontSize="20" fontWeight="500" color={color} className={url ? cn.underlined : ''}>
              {`${firstName} ${lastName || ''}`}
            </Text>
          ) : (
            <Text tag="span" fontSize="20" fontWeight="500" color={color} className={url ? cn.underlined : ''}>
              {type !== sportsDetailCardtypes.TEAMS ? lastName : teamName}
            </Text>
          )}

          {teamName && type !== sportsDetailCardtypes.TEAMS ? (
            <Text tag="span" fontSize="16" color={color} className={cn.spaced}>
              {teamName}
            </Text>
          ) : null}
        </div>
        {url ? (
          <div className={cn.arrow}>
            <IconChevronRight size="xsmall" color={color} />
          </div>
        ) : null}
      </div>
      {role ? (
        <div className={`${cn.role} ${cn.uppercase} ${cn.spaced}`}>
          <Text tag="span" fontWeight="500" fontSize="14" color="blue">
            {role}
          </Text>
        </div>
      ) : null}
    </div>
  );
};

export default PlayerCardFooter;
